/// <reference path="../fanbase/Config.js" />
// import {
// //  baseDomain,
// //  baseEnv,
//   baseSurveyID,
//   baseProjectID,
// } from "../fanbase/Config.js";

import axios from "axios";
import NProgress from "nprogress";

axios.interceptors.request.use(config => {
    NProgress.start()
    return config
})
axios.interceptors.response.use(response => {
    NProgress.done()
    return response
})


const baseDomain = process.env.VUE_APP_BASEDOMAIN;
const configDomain = process.env.VUE_APP_CONFIGDOMAIN;
const baseEnv = process.env.VUE_APP_BASEENV;

const baseUrl = `${baseDomain}/${baseEnv}`;

export class Survey {
  constructor() {}

  Start(Cpf, Mobile, Id, Prj, Params, registerId, registerMsg) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseUrl}/Start`;
      const payload = {
        userCode: Cpf,
        mobile: Mobile,
        surveyID: parseInt(Id, 10),
        projectID: parseInt(Prj, 10),
        Params: Params,
        registerId: registerId || '',
        registerMsg: registerMsg || ''
      }

      axios
        .post(cmd, payload)
        .then(
          (r) => {
            if (r.data.header.codigo == 1) {
              resolve({...r.data.data, msg: r.data.header.msg});
            }
            else if (r.data.header.codigo == 400) {
              resolve({...r.data.data, msg: "Erro de conexão, verifique sua conexão de internet!"});
            } else {
              reject(r.data.header.msg);
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  PrevResult(id){
    return new Promise((resolve, reject) => {
      const cmd = `${baseUrl}/preresult/${id}`;
      axios
        .get(cmd)
        .then(
          (r) => {
            if (r.data.header.codigo == 0 || r.data.header.codigo == 1) {
              resolve(r.data.data);
            } else {
              reject(r.data.header.msg);
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  CheckInvite(Id, Prj, Params) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseUrl}/surveyVoucher/check2`;
      const payload = {
        surveyID: parseInt(Id, 10),
        projectID: parseInt(Prj, 10),
        Params: Params,
      }
      axios
        .post(cmd, payload)
        .then(
          (r) => {
            if (r.data.header.codigo == 1) {
              resolve(r.data);
            } else {
              reject(r.data.header.msg);
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  RefuseInvite(Id, Prj, Params) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseUrl}/surveyvoucher/refuse`;
      const payload = {
        surveyID: parseInt(Id, 10),
        projectID: parseInt(Prj, 10),
        Params: Params,
      }
      axios
        .post(cmd, payload)
        .then(
          (r) => {
            if (r.data.header.codigo == 1) {
              resolve(r.data);
            } else {
              reject(r.data.header.msg);
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  addGuest(projId, inviteId, guestName) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseUrl}/surveyvoucher/addguest`;
      const payload = {
        projId: parseInt(projId, 10),
        inviteIdPrincipal: inviteId,
        guestName: guestName
      }
      axios
        .post(cmd, payload)
        .then(
          (r) => {
            if (r.data.header.codigo == 1) {
              resolve(r.data);
            } else {
              reject(r.data.header.msg);
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  }



  EndSurvey(userSurveyId) {
    return new Promise((resolve, reject) => {
      //const cmd = `${baseUrl}/EndSurvey?surveyId=${userSurveyId}`;
      const cmd = `${baseUrl}/EndSurvey/${userSurveyId}`;
      axios.post(cmd).then(
        (r) => {
          if (r.data.header.codigo == 1) {
            resolve(r.data);
          } else {
            reject(r.data.header.msg);
          }
        },
        (err) => {
          reject(err.message);
        }
      );
    });
  }
  GetEndSurvey(userSurveyId) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseUrl}/EndSurvey/${userSurveyId}`;
      axios.get(cmd).then(
        (r) => {
          if (r.data.header.codigo == 1) {
            resolve(r.data);
          } else {
            reject(r.data.header.msg);
          }
        },
        (err) => {
          reject(err.message);
        }
      );
    });
  }
  SurveyVoucher(userSurveyId) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseUrl}/SurveyVoucher/generate/${userSurveyId}`;
      axios.post(cmd).then(
        (r) => {
          if (r.data.header.codigo === 1) {
            resolve(r.data.data);
          } else if (r.data.header.codigo === 0) {
            reject(r.data.header.msg);
          } else {
            reject(r.data.data);
          }
        },
        (err) => {
          reject(err);
        }
      );
    });
  }
  getBiometry(userSurveyId) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseUrl}/registerbiometry/${userSurveyId}`;
      axios.post(cmd).then(
        (r) => {
          if (r.data.header.codigo === 1) {
            resolve(r.data.data);
          } else if (r.data.header.codigo === 0) {
            reject(r.data.header.msg);
          } else {
            reject(r.data.data);
          }
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  CheckStart(Id, Prj, mobile, code, userCodeType, params) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseUrl}/CheckStart`;
      var Mobile = "";
      axios
        .post(cmd, {
          surveyID: parseInt(Id, 10),
          projectID: parseInt(Prj, 10),
          mobile: Mobile,
          userCode: code,
          userCodeType,
          params
        })
        .then(
          (r) => {
            if (r.data.header.codigo == 1) {
              resolve(r.data.data);
            } else {
              reject(r.data.header.msg);
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  AddAnswer(userSurveyId, questionId, answer) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseUrl}/Answer`;

      axios
        .post(cmd, {
          userSurveyId: userSurveyId,
          questionId: questionId,
          answer: answer,
        })
        .then(
          (r) => {
            if (r.data.header.codigo == 1) {
              resolve(r.data.header.msg);
            } else {
              reject(r.data.header.msg);
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  }

  SaveAnswers(userSurveyId, req, chap, answers) {
    return new Promise((resolve, reject) => {
      const cmd = `${baseUrl}/saveanswers`;

      axios
        .post(cmd, {
          userSurveyId: userSurveyId,
          req: req,
          chap: chap,
          answers: answers,
        })
        .then(
          (r) => {
            if (r.data.header.codigo == 1) {
              resolve(r.data.header.msg);
            } else {
              reject(r.data.header.msg);
            }
          },
          (err) => {
            reject(err);
          }
        );
    });
  }
}

export class Register {
  constructor() {}

  registerProfile(payload) {
    return new Promise((resolve, reject) => {
      const url = `${baseUrl}/register`
      axios
        .post(url, payload)
        .then(
          (r) => {
            if (r.data.header.codigo == 1) {
              resolve(r.data);
            } else {
              reject(r.data.header.msg);
            }
          },
          (err) => {
            reject(err);
          }
        );
    })
  }

}

export class utils {
  constructor() {}

  getCep(cep) {
    return new Promise((resolve, reject) => {
      if (cep.length == 8) {
        axios.get(`https://viacep.com.br/ws/${cep}/json/`).then(
          (response) => {
            resolve(response.data);
          },
          (error) => {
            reject(error);
          }
        );
      }
    });
    }


    // getFileContent(file) {
    //
    //     return new Promise((resolve, reject) => {
    //         const url = `${configDomain}/prj/${baseProjectID}/${file}`;
    //         axios.get(url).then((response) => {
    //             resolve(response.data);
    //         }, (error) => {
    //             reject(error);
    //         });
    //
    //     });
    // }

    getFileContentLoc(prj, file, customPath = '') {

        return new Promise((resolve, reject) => {
            const url = customPath ? customPath : `${configDomain}/prj/${prj}/${file}`;

            axios.get(url).then((response) => {
                resolve(response.data);
            }, (error) => {
                reject(error);
            });
        });
    }


}
